"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickDrawService = void 0;
var api_1 = require("./api");
var PATH_V1 = 'quickdraw/api/v1';
var QuickDrawService = /** @class */ (function () {
    function QuickDrawService() {
    }
    QuickDrawService.getLatestQuickDrawWithWinnerResultByGame = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.API.get({
                                url: PATH_V1 + "/quickdraw/" + id + "/latest"
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _a.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    QuickDrawService.getQuickDrawJackpotResultsGrouped = function (gameId, page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH_V1 + "/jackpot-results-grouped?gameId.equals=" + gameId + "&page=" + (page || 0) + "&size=" + (size || 9999) + "&sort=drawDate,desc";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: response.last,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QuickDrawService.getQuickDrawJackpotResultsFromDrawDate = function (gameId, drawDateFrom, page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH_V1 + "/jackpot-results?gameId.equals=" + gameId + "&drawDate.greaterThanOrEqual=" + drawDateFrom + "&page=" + (page || 0) + "&size=" + (size || 9999) + "&sort=externalDrawId,asc";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: response.last,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    QuickDrawService.getQuickDrawJackpotResultsByDrawId = function (gameId, drawId, page, size) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = PATH_V1 + "/jackpot-results?gameId.equals=" + gameId + "&externalDrawId.equals=" + drawId + "&page=" + (page || 0) + "&size=" + (size || 9999) + "&sort=externalDrawId,asc";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api_1.API.get({ url: url })];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                content: response.content,
                                page: {
                                    first: response.first,
                                    last: response.last,
                                    totalElements: response.totalElements,
                                    totalPages: response.totalPages,
                                    number: response.number
                                }
                            }];
                    case 3:
                        error_4 = _a.sent();
                        throw error_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return QuickDrawService;
}());
exports.QuickDrawService = QuickDrawService;
//# sourceMappingURL=quick-draw-service.js.map